import {
  COMPONENT_VALUE_TYPES as types, THREE_POSITION_LAYOUTS, TWO_ROW_TEXT_LAYOUTS, FONT_FAMILIES, FONT_SIZES, FONT_COLORS, PADDING_TYPE, FONT_FAMILY_ROBOTO
} from 'shared/constants';


const propsSchema = [
  {
    key: 'title',
    label: 'Title',
    type: types.OBJECT,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT
      },
      {
        key: 'position',
        label: 'Title Position (left/central/right)',
        type: types.ENUM,
        options: THREE_POSITION_LAYOUTS
      },
      {
        key: 'font_family',
        label: 'Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.ENUM,
        options: FONT_COLORS
      },
      {
        key: 'font_size',
        label: 'Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
    ]
  },
  {
    key: 'subtitle',
    label: 'Sub Title',
    type: types.OBJECT,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT
      },
      {
        key: 'position',
        label: 'Sub Title Position (left/central/right)',
        type: types.ENUM,
        options: THREE_POSITION_LAYOUTS
      },
      {
        key: 'font_family',
        label: 'Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.ENUM,
        options: FONT_COLORS
      },
      {
        key: 'font_size',
        label: 'Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
    ]
  },
  {
    key: 'separator',
    label: 'Separator',
    type: types.OBJECT,
    children: [
      {
        key: 'thickness',
        label: 'Thickness (px)',
        type: types.TEXT
      },
      {
        key: 'length',
        label: 'Length (%)',
        type: types.TEXT
      },
      {
        key: 'position',
        label: 'Position (left/central/right)',
        type: types.ENUM,
        options: THREE_POSITION_LAYOUTS
      },
      {
        key: 'layout',
        label: 'Layout (top/bottom)',
        type: types.ENUM,
        options: TWO_ROW_TEXT_LAYOUTS
      },
      {
        key: 'color',
        label: 'Color',
        type: types.COLOR_PICKER
      }
    ]
  },
  {
    key: 'padding_type',
    label: 'Padding Type',
    type: types.ENUM,
    options: PADDING_TYPE
  },
];

const defaultProps = {
  title: {
    text: 'Page Title',
    position: 'CENTRAL',
    font_family: 'Sectra',
    font_color: 'Brand',
    font_size: '45',
  },
  subtitle: {
    text: 'Optional sub title',
    position: 'CENTRAL',
    font_family: FONT_FAMILY_ROBOTO,
    font_color: 'Brand',
    font_size: '10',
  },
  separator: {
    thickness: '3',
    length: '80',
    position: 'LEFT',
    layout: 'BOTTOM',
    color: 'Red',
  },
  padding_type: PADDING_TYPE[0]
};

export default {
  title: 'Title',
  id: 'TitleText',
  propsSchema,
  defaultProps
};
